export const GRID_PAGE_SIZE = 20;
export const DROPDOWN_SIZE = 1000;
import { FileRestrictions } from '@progress/kendo-angular-upload';
export const CONSTANT_FILE_RESTRICTIONS: FileRestrictions = {
  allowedExtensions: [
    '.txt',
    '.docx',
    '.jpeg',
    '.jpg',
    '.png',
    '.pdf',
    '.xlsx'
  ],
  maxFileSize: 26214400
};

export const FILE_ERROR_MESSAGE = `Wrong type or size of files. Allowed size is ${
  CONSTANT_FILE_RESTRICTIONS!.maxFileSize! / (1024 * 1024)
} MB. Allowed extensions are : ${CONSTANT_FILE_RESTRICTIONS.allowedExtensions?.join(
  ' '
)}`;

export type Nullable<T> = T | null | undefined;
